import { menuController } from '@ionic/vue'

// 菜单
const menu = () => { menuController.toggle() }

menu.open = () => { menuController.open() }
menu.close = () => { menuController.close() }

export { menu }